import { quadraticspline } from "./spline";

function rangef(n, func) {
  const a = new Array(n);
  for (let i = 0; i < n; i++) {
    a[i] = func(i);
  }
  return a;
}

function undefined2zero_inplace(v) {
  for (let i = 0; i < v.length; i++) {
    v[i] = v[i] || 0;
  }
}

export default function emissions2interpolatedtracks(
  emissions,
  points_per_year,
  points_per_y
) {
  let interpolated = interpolate(emissions, points_per_year);
  let tracks = emissions2tracks(interpolated, points_per_y);
  tracks = replaceinfinity(tracks); //Avfall with emissions only zeros get Inf
  return tracks;
}

function replaceinfinity(tracks) {
  return tracks.map((track) => track.map((v) => (isFinite(v) ? v : 1)));
}

function interpolate(emissions, points_per_year) {
  return emissions.map(
    (em) => smooth_curve(em, 0, points_per_year).interpolated_emissions
  );
}

function smooth_curve(h, first_year = 0, resolution = 5) {
  let n_years = h.length;
  let h_x = rangef(n_years, (t) => first_year + t + 1);
  let interpolated_years = rangef(
    Math.ceil(n_years * resolution),
    (t) => first_year + t / resolution + 0.5 / resolution
  );
  let interpolated_emissions = quadraticspline(h_x, h, interpolated_years);
  undefined2zero_inplace(interpolated_emissions);
  return { interpolated_years, interpolated_emissions };
}

function emissions2tracks(emissionslist, points_per_y) {
  return emissionslist.map((emissions) =>
    emissions2track(emissions, points_per_y)
  );
}

function emissions2track(emissions, points_per_y) {
  return emissions.map((em) => Math.round(em * points_per_y));
}
